// extracted by mini-css-extract-plugin
export var quantityInput = "_ga-0";